import { mount } from "@vue/test-utils";
import RadioItem from "@/components/core/RadioItem";

describe("RadioItem test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(RadioItem);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component RadioItem", () => {
    expect(wrapper).toBeDefined();
  });
});
